// extracted by mini-css-extract-plugin
module.exports = {"mallList__list":"style_mallList__list__8MInO","skeleton-list":"style_skeleton-list__BW4TD"};